import React from 'react';
import Modal from 'react-modal';
import merge from 'lodash/merge'
import { IoIosClose } from 'react-icons/io';

import Box from './Box'
import Button from './Button';
import theme, { responsive } from './ThemeProvider/theme'

Modal.setAppElement('#___gatsby')

const defaultStyles = {
  overlay: {
    zIndex: theme.zOrder[3],
    backgroundColor: 'rgba(0,0,0,0.7)',
    overflow: 'auto'
  },
  content: {
    width: '90%',
    display: 'flex',
    maxWidth: '70em',
    top: theme.headerHeight[3],
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginBottom: theme.headerHeight[3],
    marginRight: '-50%',
    transform: 'translate(-50%)',
    padding: 0,
    backgroundColor: 'white',
    overflow: 'unset',
  }
};

export default ({
  children,
  border,
  borderRadius,
  customStyles,
  py,
  p,
  closeIcon,
  onRequestClose,
  ...props
}) => (
  <Modal
    style={merge({}, defaultStyles, { content: customStyles })}
    onRequestClose={onRequestClose}
    {...props}
  >
    {closeIcon &&  (
      <Box position="absolute" top="1em" right="1em">
        <Button.Transparent
          display="inline-block"
          color="white"
          bg="darkPurple"
          hoverBg="darkPurple"
          lineHeight="0"
          px="0"
          py="0"
          onClick={onRequestClose}
          aria-label="關閉個資法規說明"
        >
          <IoIosClose size="2.5em" />
        </Button.Transparent>
      </Box>
    )}
    <Box mx="auto" p={p || responsive('2.625em 0.875em', '5.75em 10em')}>
      {children}
    </Box>
  </Modal>
)
